import { motion } from "framer-motion";

/**
 * Reveals a phrase word-by-word with a 3D "pop" (each word rotates up from
 * flat and springs forward in Z). Pass `gold` indices to colour specific words.
 */
export const Words3D = ({ text, goldWords = [], className = "", delay = 0, italicWords = [] }) => {
  const words = text.split(" ");
  return (
    <span className={className} style={{ perspective: "800px", display: "inline-block" }} data-testid="words-3d">
      {words.map((w, i) => (
        <motion.span
          key={`${w}-${i}`}
          initial={{ opacity: 0, rotateX: -90, z: -120, y: 18 }}
          animate={{ opacity: 1, rotateX: 0, z: 0, y: 0 }}
          transition={{ delay: delay + i * 0.16, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          style={{ display: "inline-block", transformStyle: "preserve-3d", transformOrigin: "bottom center", marginRight: "0.28em" }}
          className={`${goldWords.includes(i) ? "gold-text" : ""} ${italicWords.includes(i) ? "italic" : ""}`}
        >
          {w}
        </motion.span>
      ))}
    </span>
  );
};
